export default __webpack_public_path__ + "locales/fi/InviteDialog.json?hash=1349d321d8ae77a36f69fa1948a8ac61";